import { polarClient } from "@polar-sh/better-auth/client";
import { createAuthClient } from "better-auth/client";
import { API_BASE_URL } from "./api";

export const authClient = createAuthClient({
  baseURL: API_BASE_URL,
  plugins: [polarClient()],
});

export type AuthClient = typeof authClient;
